import { Outlet, Route } from 'react-router-dom';
import ForestDataHubHeader from '../components/header/Header';
import {
  CoreView,
  OverView,
  StarterView,
  SupportView,
} from './DocumentationPages/GeneralDocPages';
import DocumentationBasePage from './DocumentationBasePage';
import { ItsView, ClmView } from './DocumentationPages/DataCollectionDocPages';
import { GeoserverInfoView } from './DocumentationPages/ThirdPartyIntegrationDocPages';
import {
  DownloadCatalogInfoView,
  SearchCatalogInfoView,
} from './DocumentationPages/DataCatalogDocPages';
import {
  DownloadMapInfoView,
  ITSReportInfoView,
  VisualDatasetInfoView,
} from './DocumentationPages/WorkspaceDocPages';

export const DocumentationRoute = (
  <Route path="/documentation">
    <Route
      index
      element={
        <>
          <ForestDataHubHeader>
            <DocumentationBasePage>
              <OverView />
            </DocumentationBasePage>
          </ForestDataHubHeader>
        </>
      }
    />
    <Route
      path="features"
      element={
        <>
          <ForestDataHubHeader>
            <DocumentationBasePage>
              <CoreView />
            </DocumentationBasePage>
          </ForestDataHubHeader>
        </>
      }
    />
    <Route
      path="gettingstarted"
      element={
        <>
          <ForestDataHubHeader>
            <DocumentationBasePage>
              <StarterView />
            </DocumentationBasePage>
          </ForestDataHubHeader>
        </>
      }
    />
    <Route
      path="catalog"
      element={
        <>
          <ForestDataHubHeader>
            <DocumentationBasePage>
              <Outlet />
            </DocumentationBasePage>
          </ForestDataHubHeader>
        </>
      }
    >
      <Route path="search" element={<SearchCatalogInfoView />} />
      <Route path="download" element={<DownloadCatalogInfoView />} />
    </Route>
    {/* <Route
      path="collections"
      element={
        <>
          <ForestDataHubHeader>
            <DocumentationBasePage>
              <Outlet />
            </DocumentationBasePage>
          </ForestDataHubHeader>
        </>
      }
    >
      <Route path="its" element={<ItsView />} />
      <Route path="clm" element={<ClmView />} />
    </Route> */}
    <Route
      path="mapviewer"
      element={
        <>
          <ForestDataHubHeader>
            <DocumentationBasePage>
              <Outlet />
            </DocumentationBasePage>
          </ForestDataHubHeader>
        </>
      }
    >
      <Route path="dataset" element={<VisualDatasetInfoView />} />
      <Route path="download" element={<DownloadMapInfoView />} />
      <Route path="its" element={<ITSReportInfoView />} />
    </Route>
    <Route
      path="mappingtools"
      element={
        <>
          <ForestDataHubHeader>
            <DocumentationBasePage>
              <GeoserverInfoView />
            </DocumentationBasePage>
          </ForestDataHubHeader>
        </>
      }
    />
    {/* <Route
      path="support"
      element={
        <>
          <ForestDataHubHeader>
            <DocumentationBasePage>
              <SupportView />
            </DocumentationBasePage>
          </ForestDataHubHeader>
        </>
      }
    /> */}
  </Route>
);
export default DocumentationRoute;
